import React from "react";
import { Field } from "formik";
import { TextFormFieldWithError } from "../../ui/form-fields/text-form-field-with-error";

export const CourierText = ({
  label,
  name,
  type = "text",
  placeholder = "",
  span = false
}) => (
  <div className={`form-row${span ? " span-all" : ""}`}>
    <label>{label}</label>
    <Field
      type={type}
      name={name}
      placeholder={placeholder}
      component={TextFormFieldWithError}
    />
  </div>
);

export const CourierReadonly = ({ label, value, span = false }) => (
  <div className={`form-row${span ? " span-all" : ""}`}>
    <label>{label}</label>
    <div className="no-editable">{value || "—"}</div>
  </div>
);

export const CourierCheck = ({ label, checked, onChange }) => (
  <div className="form-row">
    <label className="custom-checkbox">
      <input type="checkbox" checked={checked} onChange={onChange} />
      <span className="fake-checkbox" />
      <span className="text">{label}</span>
    </label>
  </div>
);

export const CourierActions = ({ loading, submitLabel, disabled }) => (
  <button
    type="submit"
    className="create-btn"
    disabled={loading || disabled}
  >
    {loading ? "Saving…" : submitLabel}
  </button>
);
